
import { MENU_BOOK_VISITED } from "@/constants/MixpanelEvents.js";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

import Vue from "vue";
import VueWaypoint from "vue-waypoint";

Vue.use(VueWaypoint);

export default {
  components: {
    infoDialogMobile: () =>
      import("@/components/dialogs/info-dialog-mobile.vue"),
    menuAssistanceDialog: () =>
      import("@/components/dialogs/menu-assistance-dialog.vue"),
    menuHeaderRow: () => import("@/components/menu/menu-header-row.vue"),
    MenuNormalView: () => import("@/components/menu/menu-normal-view.vue"),
    MenuNoData: () => import("@/components/menu/menu-no-data.vue"),
    MenuLandingPage: () => import("@/components/menu/menu-landing-page.vue"),
    MenuHeaderSearchField: () =>
      import("@/components/menu/menu-header-search-field.vue"),
    AddonsList: () => import("@/components/menu/addons-list.vue"),
    MenuComboList: () => import("@/components/menu/menu-combo-list.vue"),
    menuItemForm: () => import("@/components/menu/menu-item-form.vue"),
    RemoveModifyItemDialog: () =>
      import("@/components/dialogs/remove-modify-item-dialog.vue"),
    MenuCreateAddon: () => import("@/components/menu/menu-create-addon.vue"),
    MenuCreateCombo: () => import("@/components/menu/menu-create-combo.vue")
  },
  data: () => {
    return {
      tab: 0,
      tabs: { TAB_MENU_ITEMS: 0, TAB_ADDONS: 1, TAB_COMBOS: 2 },
      categories: [
        { id: "menu", label: "Items" },
        { id: "addons", label: "Add-ons" },
        { id: "combos", label: "Combos" }
      ],
      showMenuAssistanceDialog: false,
      showUploadingRequestSendDialog: false,
      showExpansionContent: false,
      selectedItem: ""
    };
  },
  computed: {
    ...mapState("menu", [
      "menuLoading",
      "menuItems",
      "addons",
      "combosList",
      "searchBy"
    ]),
    ...mapGetters("menu", ["getGroupedMenu"]),
    ...mapState("restaurant", ["locationDetails"]),
    hasNoMenuData() {
      return !this.isMenuItems && !this.isCombos;
    },
    isMenuItems() {
      return this.menuItems && this.menuItems.length;
    },
    isAddons() {
      return this.addons && this.addons.length;
    },
    isCombos() {
      return this.combosList && this.combosList.length;
    },

    ...mapGetters("menu", ["getGroupedMenu"]),

    getGroupedItemsSearchResult() {
      if (this.searchBy && this.searchBy.trim() !== "") {
        let groupedItemsSearchResult = [];
        this.getGroupedMenu.forEach((group, groupIndex) => {
          let groupItem = {};
          groupItem.id = group.id;
          groupItem.label = group.label;
          groupItem.items = [];
          group.items.forEach((item) => {
            let lastCharFoundIndex = -1,
              isMatch = true;
            this.searchBy
              .toLowerCase()
              .split("")
              .forEach((searchChar) => {
                const foundIndex = String(item.item_name || item.name || "")
                  .toLowerCase()
                  .indexOf(searchChar, lastCharFoundIndex + 1);
                if (isMatch && foundIndex > lastCharFoundIndex) {
                  lastCharFoundIndex = foundIndex;
                } else {
                  isMatch = false;
                }
              });

            if (isMatch) {
              groupItem.items.push(item);
            }
          });
          groupedItemsSearchResult.push(groupItem);
        });
        return groupedItemsSearchResult;
      } else {
        return this.getGroupedMenu;
      }
    }
  },
  beforeMount() {
    this.getAddons();
    this.getCombosList();
  },
  async fetch() {
    this.SET_MENU_LOADING(true);
    await this.getMenuList(true);
    this.SET_MENU_LOADING(false);
  },
  created() {
    this.getSyncStatus();
  },

  mounted() {
    this.mixPanelTrackEvent(MENU_BOOK_VISITED);
  },
  methods: {
    ...mapActions("menu", [
      "getMenuList",
      "getSyncStatus",
      "getAddons",
      "getCombosList"
    ]),
    ...mapMutations("menu", ["SET_MENU_LOADING"]),
    handleShowRemoveModifyItemDialog(item) {
      this.showExpansionContent = true;
      this.selectedItem = item;
    }
  }
};
